import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { MainLayoutPage } from './main-layout.page';
import { MenuPageModule} from '../../components/menu/menu.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatListModule, MatMenuModule, MatButtonModule, MatTooltipModule, MatToolbarModule, MatIconModule,
  MatSidenavModule} from '@angular/material';

const routes: Routes = [
  {
    path: '',
    component: MainLayoutPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MatListModule,
    MatButtonModule,
    MatToolbarModule,
    MatTooltipModule,
    MatMenuModule,

    MatSidenavModule,

    FontAwesomeModule,
    MatIconModule,
    MenuPageModule,
    RouterModule.forChild(routes)
  ],
  exports: [
    MainLayoutPage
  ],
  declarations: [MainLayoutPage]
})
export class MainLayoutPageModule {}
